import gql from "graphql-tag";

export default gql`
  query carById($carid: Int!) {
    carsForSaleById(id: $carid) {
      id
      year
      make
      model
      price
      description
      sellerId
      mileage
      imageLoc
      videoLoc
      createdAt
      latitude
      longitude
      locationAddress
      vin
      trim
      identityDisplayTitle
      transmission
      fuelType
      engine
      driveType
      bodyStyle
      exteriorColor
      interiorColor
      titleStatus
      titleImageKey
      hasVerifiedTitle
      active
      sold
      seller: userBySellerId {
        id
      }
    }
  }
`;
